<template>         
    <div v-if="dataimpresion" id="printme" style="text-align: center; font-size: 10px;">
        <!-- style="width: 460px; min-height: 900px;" -->
         <!-- font-family: Roboto Mono; margin-top: -15px; -->
        <div class="ticket">
            <!-- Datos del emisor -->
            <div class="text-center" style="text-align: center; font-size: 14px;">
                <b-row>
                    <b-col>
                        <template v-if="checked">
                             <!-- :width="ancho+'px'"  -->
                            <img :src="urlimagen" :height="alto+'px'" width="70%" style="margin-left:auto; margin-right:auto;"/>
                        </template>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <template v-if="nombreComercial">
                            <b>{{ nombreComercial }}</b> 
                        </template>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <template>
                            RUC: <b>{{ this.$store.getters.userData.cuenta.idEmisor }}</b> 
                        </template>
                    </b-col>
                </b-row>
                
                <b-row>
                    <b-col>
                        <template v-if="direccion">
                            {{ direccion }}
                        </template>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <template v-if="telefono">
                          Telf: <b>{{ telefono }}</b>
                        </template>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <template v-if="correo">
                            {{ correo }}
                        </template>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <template v-if="paginaWeb">
                            {{ paginaWeb }}
                        </template>
                    </b-col>
                </b-row>
            </div>
            <div class="text-center" style="text-align: center; font-size: 17px;">
                <template v-if="dataimpresion.serie">
                   <div v-if="dataimpresion.serie.substr(0,1) == 'B'">
                     <span class="text-center"><b>BOLETA DE VENTA ELECTRÓNICA </b></span>
                   </div>
                </template>
                <template v-if="dataimpresion.serie">
                    <div v-if="dataimpresion.serie.substr(0,1) == 'F'">
                        <span class="text-center"><b>FACTURA ELECTRÓNICA </b></span>
                    </div>
                </template>
                <template v-if="dataimpresion.serie">
                    <div v-if="dataimpresion.serie.substr(0,1) == 'P'">
                        <span class="text-center"><b>PROFORMA </b></span>
                    </div>
                </template>
            </div>
            <div class="text-center" style="text-align: center; font-size: 14px;">
                <template v-if="dataimpresion.serie && dataimpresion.numero">
                    <b>{{ dataimpresion.serie }}-{{ dataimpresion.numero }}</b>
                </template>
            </div>
            <!-- Datos del receptor -->
            
            <div class="text-left" style="font-size: 14px;">
                    <template>
                        <div v-if="dataimpresion.idReceptor" style="display: inline-block; float: left; width: 50%; font-size: 14px;">
                            <b>Documento:</b> {{dataimpresion.idReceptor}}
                        </div>
                        <div style="display: inline-block; float: rigth; width: 50%; font-size: 14px;">
                            <div v-if="dataimpresion && dataimpresion.adicional && dataimpresion.adicional.username">
                                <b>Usuario:</b> {{ this.dataimpresion.adicional.username }}
                            </div>                          
                        </div>
                    </template>
                    <!-- inicio PROFORMA -->
                    <template>
                        <div v-if="dataimpresion && dataimpresion.proforma" style="display: inline-block; float: left; width: 50%; font-size: 14px;">
                            <b>Documento:</b> {{dataimpresion.proforma.receptor.nro}}
                        </div>
                        <div style="display: inline-block; float: rigth; width: 50%; font-size: 14px;">
                            <div v-if="dataimpresion && dataimpresion.proforma">
                                <b>Usuario:</b> {{ this.dataimpresion.proforma.adicional.username }}
                            </div>                          
                        </div>
                    </template>
                    <div v-if="dataimpresion && dataimpresion.proforma">
                        <b>Razon Social:</b> {{ dataimpresion.proforma.receptor.razonSocial }}
                    </div>
                    <div v-if="dataimpresion && dataimpresion.proforma">
                        <b>Direccion:</b>
                        <template v-if="dataimpresion && dataimpresion.proforma"> 
                            {{ dataimpresion.proforma.receptor.direccionFiscal }} 
                        </template>                        
                    </div>
                    <template>
                        <div v-if="dataimpresion && dataimpresion.proforma" style="display: inline-block; float: left; width: 60%; font-size: 14px;">
                            <b>Fecha:</b> {{ dataimpresion.created_at | moment('D/M/Y') }} - <b>Hora:</b> {{ dataimpresion.created_at | moment('hh:mm A') }}
                        </div>
                        <div v-if="dataimpresion && dataimpresion.proforma" style="display: inline-block; float: rigth; width: 40%; font-size: 14px;">
                            <b>Moneda:</b> {{ dataimpresion.proforma.moneda }} <br>
                        </div>
                    </template>
                    <!-- fin PROFORMA -->
                        <div v-if="dataimpresion && dataimpresion.receiver">
                            <b>Razon Social:</b> {{ dataimpresion.receiver.razonSocial }}
                        </div>
                        <div v-if="dataimpresion && dataimpresion.receiver">
                            <b>Direccion:</b>
                            <template v-if="dataimpresion.idReceptor.substr(1,2) == '20'"> {{ dataimpresion.receiver.direccionReferencia }} </template>
                            <template v-else>{{ dataimpresion.adicional.dirAlternativa }} </template>                          
                        </div>
                    <template>
                        <div v-if="dataimpresion.fechaEmision" style="display: inline-block; float: left; width: 60%; font-size: 14px;">
                            <b>Fecha:</b> {{ dataimpresion.fechaEmision | moment('D/M/Y') }} - <b>Hora:</b> {{ dataimpresion.fechaEmision | moment('hh:mm:ss A') }}
                        </div>
                        <div v-if="dataimpresion.tipoMoneda" style="display: inline-block; float: rigth; width: 40%; font-size: 14px;">
                            <b>Moneda:</b> {{ dataimpresion.tipoMoneda }} <br>
                        </div>
                    </template>
                    <template>
                        <div v-if="dataimpresion.adicional" style="display: inline-block; float: left; width: 60%; font-size: 14px;">
                            <b>Forma de Pago:</b> {{ dataimpresion.adicional.nombreFormaPago}}
                        </div>
                    </template>
                    <template>
                        <div style="display: inline-block;" v-if="dataimpresion && dataimpresion.lista">
                            <b>Placa:</b>
                        <div v-for="(item, index) in dataimpresion.lista" :key="index">
                            {{ JSON.parse(item.adicional).numeroPlacaVehiculo }}
                        </div>
                        </div>
                    </template>
                    
            </div>
            <br>
            <b-row class="mt-3">
                <b-col>
                    <div style="display: inline-block; float: left; width: 50%; font-size: 14px;">
                        <b>ART&Iacute;CULO</b>
                    </div>
                    <div class="text-right" style="text-align: right; font-size: 14px; float:rigth; display: inline-block; width: 50%;">
                        <b>SUBTOTAL</b>
                    </div>
                </b-col>
            </b-row>
            <template>
            <b-row v-for="(item, index) in dataimpresion.lista" :key="index">
                <b-col>
                    <div class="text-left" style="text-align: left; font-size: 14px; margin: 0px; padding: 0px; display: inline-block; float: left; width: 80%;">
                        <span style="margin: 0;">
                            <div v-if="item && item.adicional && item.adicional.numeroPlacaVehiculo">
                                {{item.descripcion}} - Placa: {{ item.adicional.numeroPlacaVehiculo }}
                            </div>
                            <div v-else>
                                {{item.descripcion}}
                            </div>
                        </span>
                        <span style="margin-left: 14px;">
                            {{(parseFloat(item.cantidad))}} x {{parseFloat((item.precioVentaUnitario))}}
                        </span>
                    </div>
                    <div class="text-right" style="text-align: right; font-size: 14px; margin: 0px; padding: 0px; display: inline-block; float: right; width: 20%;">
                        <span v-if="item && item.cantidad && item.precioVentaUnitario">
                            {{ (item.cantidad*item.precioVentaUnitario).toFixed(2) }}
                        </span>
                    </div>
                </b-col>
            </b-row>
            <!-- INICIO ITEMS PROFORMA -->
            <template v-if="dataimpresion.proforma">
                <div>
            <b-row v-for="(item, index) in dataimpresion.proforma.items" :key="index">
                <b-col>
                    <div class="text-left" style="text-align: left; font-size: 14px; margin: 0px; padding: 0px; display: inline-block; float: left; width: 80%;">
                        <span style="margin: 0;">
                            <div>
                                {{item.descripcion}}
                            </div>
                        </span>
                        <span style="margin-left: 14px;">
                            {{(parseFloat(item.cantidad))}} x {{parseFloat((item.precioVentaUnitario))}}
                        </span>
                    </div>
                    <div class="text-right" style="text-align: right; font-size: 14px; margin: 0px; padding: 0px; display: inline-block; float: right; width: 20%;">
                        <span v-if="item && item.cantidad && item.precioVentaUnitario">
                            {{ (item.cantidad*item.precioVentaUnitario).toFixed(2) }}
                        </span>
                    </div>
                </b-col>
            </b-row>
                </div>
            </template>
            <!-- FIN ITEMS PROFORMA -->
            </template>
            <br>
            <div>
                <div class="text-left" style="text-align: left; display: inline-block; width: 60%; font-size: 14px;">
                    <b>Op. Gravada</b><br>
                    <b>I.G.V.</b><br>
                    <div v-if="dataimpresion && dataimpresion.sumatoriaOtrosCargos">
                        <b>Otros Cargos</b>
                    </div>
                    <b>Importe Total</b><br>
                </div>
                <div class="text-right" style="text-align: right;  display: inline-block; width: 5%; font-size: 14px;">
                    {{ simbolo }}<br>
                    {{ simbolo }}<br>
                    {{ simbolo }}<br>
                    <div v-if="dataimpresion && dataimpresion.sumatoriaOtrosCargos">
                    {{ simbolo }}
                    </div>
                </div>
                <div v-if="dataimpresion" style="text-align: right; display: inline-block; width: 30%; font-size: 14px;">
                    <div class="text-right" v-if="dataimpresion && dataimpresion.totalVentaGravada">
                        {{ dataimpresion.totalVentaGravada}}
                    </div>
                    <div class="text-right" v-if="dataimpresion && dataimpresion.proforma">
                        {{ dataimpresion.proforma.totales.totalVentaGravada.toFixed(2)}}
                    </div>
                    <div class="text-right" v-if="dataimpresion && dataimpresion.totalVentaGravada == 0">
                       0.00
                    </div>
                    <div class="text-right" v-if="dataimpresion && dataimpresion.sumatoriaIgv">
                        {{ dataimpresion.sumatoriaIgv}}
                    </div>
                    <div class="text-right" v-if="dataimpresion && dataimpresion.proforma">
                        {{ dataimpresion.proforma.totales.sumatoriaIgv.toFixed(2)}}
                    </div>
                    <div class="text-right" v-if="dataimpresion.sumatoriaIgv == 0">
                        0.00
                    </div>
                    <div class="text-right" v-if="dataimpresion && dataimpresion.sumatoriaOtrosCargos">
                        {{ dataimpresion.sumatoriaOtrosCargos}}
                    </div>
                    <div v-if="dataimpresion && dataimpresion.importeTotal" class="text-right">  
                        {{ dataimpresion.importeTotal}}
                    </div>
                    <div class="text-right" v-if="dataimpresion && dataimpresion.proforma">
                        {{ dataimpresion.proforma.totales.importeTotal.toFixed(2)}}
                    </div>
                </div>
            </div>  
            <b-row>
                <b-col>
                    <div class="mt-4" style="font-size: 14px;">
                        <span class="text-left">Son: {{ dataimpresion.importeLetras }} {{ dataimpresion.tipoMonedaHuman }}</span>   
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <div style="font-size: 10px;" v-if="dataimpresion && dataimpresion.adicionales && dataimpresion.adicionales.length>0">
                    <b-col xl="12">
                        Datos Adicionales
                    </b-col>
                    <b-col>
                        <ul>
                            <li v-for="(item, index) in dataimpresion.adicionales" :key="index">{{ item.key }} : {{ item.value }}</li>
                        </ul>
                    </b-col>
                </div>
            </b-row>
            <b-row>
                
            </b-row>
            <b-row>
                <b-col>
                    <template v-if="dataimpresion.digestValue!=''">
                        <div style="text-align: center; padding: 0px; margin: 0px;">
                             <template>
                                <vue-qr logoSrc="images/logofo.png" :text="makeHash()" :logoScale=0.2 :dotScale=0.9 :size="130"></vue-qr>
                            </template>
                            <div class="text-center" style="font-size: 14px;">
                                <template v-if="dataimpresion.serie">
                                    <div v-if="dataimpresion.serie.substr(0,1) == 'B'">
                                        <span class="text-center"><b>BOLETA DE VENTA ELECTRÓNICA </b></span>
                                    </div>
                                </template>
                                <template v-if="dataimpresion.serie">
                                    <div v-if="dataimpresion.serie.substr(0,1) == 'F'">
                                        <span class="text-center"><b>FACTURA ELECTRÓNICA </b></span>
                                    </div>
                                </template>
                            </div>
                            <div class="text-center" style="font-size: 14px;">
                                Autorizacion Tarjeta: {{dataimpresion.OperacionCard}}
                            </div>
                            <template>
                                <div v-if="dataimpresion.cargosDescuentosGlobales !='[]' && dataimpresion.cargosDescuentosGlobales !=null ">
                                    <div class="text-center" style="font-size: 14px;">
                                        Factura afecta a Retención del IGV : 3 %
                                    </div>
                                    <div class="text-center" style="font-size: 14px;">
                                        Base descuento : {{dataimpresion.importeTotal  }}
                                    </div>
                                    <div class="text-center" style="font-size: 14px;">
                                        Monto descuento : S/ {{ (dataimpresion.importeTotal*0.03).toFixed(2) }}
                                    </div>
                                    <div class="text-center" style="font-size: 14px;">
                                        Neto : S/ {{ (dataimpresion.importeTotal*0.97).toFixed(2) }}
                                    </div> 
                                </div>  
                            </template>
                            <div class="text-center" style="font-size: 14px;">
                                Hash: {{ dataimpresion.digestValue }}
                            </div>                        
                        </div>
                    </template>
                </b-col>
            </b-row>
            <b-row v-if="!dataimpresion.proforma">
                <b-col v-if="!dataimpresion.notaVenta">
                    <div class="text-center" style="text-align: center; font-size: 14px;padding-right: 5px;padding-left: 5px; margin-bottom: 1px;">Autorizado mediante resolución 034-030-0000103/SUNAT,<br> representación impresa del comprobante en:
                        <br> https://facturaonline.pe
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <template v-if="textoPersonalizado1 !=''">
                        <div class="text-center" style="text-align: center; font-size: 14px;">
                            {{ textoPersonalizado1 }} 
                        </div>
                    </template>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <template v-if="textoPersonalizado2 !=''">
                       <div class="text-center" style="text-align: center; font-size: 14px;">
                            {{ textoPersonalizado2 }}
                        </div>
                    </template>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import VueQr from 'vue-qr'
    export default {
        name: 'PostTicketPdf',
        props: ['impresion', 'printweb'],
        components: {
            VueQr
        },
        data:() => {
            return {
                checked: true,
                alto: '',
                // ancho: '',
                urlimagen: '',
                tipodoc: 1,
                digestvalue: '',
                dataimpresion: {},
                simbolo: '',
                hash: '',
                telefono: '',
                nombreComercial: '',
                direccion: '',
                paginaWeb: '',
                correo: '',
                textoPersonalizado1: '',
                textoPersonalizado2: ''
            }
        },
        mounted() {
            this.setData(),
            this.parsePlaca(),
            this.getDataImpresion()
            
        },
        watch: {
            printweb: function () {
                if(this.printweb){
                    var printContents = document.getElementById("printme").innerHTML
                    var myWindow = window.open("", "MsgWindow", "width=400,height=800")
                    myWindow.document.body.style.fontSize='10px'
                    myWindow.document.body.style.textAlign='center'
                    myWindow.document.write(printContents)
                    myWindow.print(printContents)
                    myWindow.close()
                }
            }
        },
        methods: {
            getDataImpresion: function () {
                axios
                .post(process.env.VUE_APP_API_URL + 'movil/informacioncliente/mostrar', {
                    token: this.$store.getters.userToken
                })
                .then(response => (
                    this.dataLogo(response.data.response)
                ))
                .catch(error => (
                    this.checked = true,
                    this.alto = '100'
                    // this.ancho = '150'
                ))
            },
            dataLogo: function (data) {
                this.telefono = data.telefono
                this.nombreComercial = data.nombreComercial
                this.direccion =  data.direccion
                this.paginaWeb = data.paginaWeb
                this.correo = data.correo
                this.textoPersonalizado1 = data.textoPersonalizado1
                this.textoPersonalizado2 = data.textoPersonalizado2
                if(data.impLogo == 1){
                    this.checked = true
                    this.alto = data.altoLogo
                    // this.ancho = data.anchoLogo
                }else if(data.impLogo == 0){
                    this.checked = false
                    this.alto = '100'
                    // this.ancho = '150'
                }
            },
            makeHash: function() {
                if(Object.keys(this.dataimpresion).length != 0){
                    let tiporec = ''
                    this.dataimpresion.tiporeceptor == '6'? tiporec = '06': tiporec = '01'
                    this.hash = this.dataimpresion.idEmisor+'|'+
                                this.dataimpresion.codigoComprobante+'|'+
                                this.dataimpresion.serie+'|'+
                                this.dataimpresion.numero+'|'+                              
                                String(this.dataimpresion.sumatoriaIgv) +'|'+
                                String(this.dataimpresion.importeTotal) +'|'+                                                       
                                this.$moment(this.dataimpresion.fechaEmision).format('DD/MM/YYYY')+'|'+
                                tiporec+'|'+
                                this.dataimpresion.idReceptor
                }
                return this.hash
            },
            setData: function () {
                this.dataimpresion = this.impresion,
                this.urlimagen = this.$store.getters.userData.cuenta.uriImagen
                if(this.dataimpresion.proforma){
                    this.tipoMoneda2()
                }else if(this.dataimpresion.codigoComprobante !=''){
                    this.tipoMoneda()
                }
            },
            tipoMoneda: function () {
                if(this.dataimpresion.tipoMoneda == 'PEN'){
                    this.simbolo = 'S/'
                }else if(this.dataimpresion.tipoMoneda == 'USD'){
                    this.simbolo = '$'
                }else if(this.dataimpresion.notaVenta.moneda.codigo == 'PEN'){
                    this.simbolo = 'S/'
                }else if(this.dataimpresion.notaVenta.moneda.codigo == 'USD'){
                    this.simbolo = '$'
                }else{
                    this.simbolo = this.dataimpresion.tipoMoneda
                 }
            },
            tipoMoneda2(){
                if(this.dataimpresion.proforma.moneda = 'PEN'){
                    this.simbolo = 'S/'
                }else if(this.dataimpresion.proforma.moneda = 'USD'){
                    this.simbolo = '$'
                }
            },
            parsePlaca(){
                if(!this.dataimpresion && this.dataimpresion.proforma){
                    let idboleta;
                    let ObjectAdicional;
                    let array = this.dataimpresion.lista
                    this.dataimpresion.lista.forEach(element => {
                        idboleta = element.idBoleta    
                        if(typeof element.adicional == 'object'){
                            console.log(' ')
                        }else{
                            ObjectAdicional = JSON.parse(element.adicional)
                                array.forEach(element => {
                                if(element.idBoleta == idboleta){
                                    element.adicional = ObjectAdicional
                                }
                            });
                        }
                    });
                    this.dataimpresion.lista = array; 
                }   
            }
        }
    }
</script>

<style lang="scss" scoped>
    .ticket{
        border: 1px solid #ccc;
        border-radius: 10px;
        padding: 10px;
    }
    // .medida{
    //     font-size: 12px;
    // }
</style>